module.exports = __webpack_public_path__ + "media/promotional/parachute-f920750c.jpeg";